import { render, staticRenderFns } from "./CaseImageForm.vue?vue&type=template&id=b4df5ae4&scoped=true&"
import script from "./CaseImageForm.vue?vue&type=script&lang=js&"
export * from "./CaseImageForm.vue?vue&type=script&lang=js&"
import style0 from "./CaseImageForm.vue?vue&type=style&index=0&id=b4df5ae4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4df5ae4",
  null
  
)

export default component.exports